import React from "react";

interface Props {
  className?: string;
}

const OrganiserIcon = (props: Props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 18H15V12H10V18ZM4 18H9V5H4V18ZM16 18H21V12H16V18ZM10 5V11H21V5H10Z"
      fill="#828282"
      className={props.className}
    />
  </svg>
);
OrganiserIcon.defaultProps = {
  className: undefined,
};

export default OrganiserIcon;
